import React from "react";
import { css, Theme, useTheme } from "@emotion/react";

type Props = {
    children: React.ReactNode,
};

const FooterMenu: React.FC<Props> = ({ children }) => {
    const theme: Theme = useTheme();

    const style = css`
        ${theme.breakpoints.up("5xl")} {
            max-width: 260px;
        }
        
        ${theme.breakpoints.between("3xl", "4xl")} {
            max-width: 185px;
        }
        
        ${theme.breakpoints.only("xxl")} {
            max-width: 172px;
        }

        ${theme.breakpoints.only("xl")} {
            max-width: 156px;
        }

        ${theme.breakpoints.only("lg")} {
            max-width: 140px;
        }
    `;

    return (
        <div css={style}>
            {children}
        </div>
    );
};

export default FooterMenu;